"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediafileGenerator = void 0;
var types_1 = require("../adCampaigns/types");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var PatternService_1 = require("./PatternService");
var GenerationRulesService_1 = require("../GenerationRulesService");
var filterMediafiles_1 = require("./filterMediafiles");
var utils_1 = require("./utils");
var BANNED_PERFORMERS_QUEUE_LENGTH = 5;
var MediafileGenerator = (function () {
    function MediafileGenerator(allBlocks, blockPattern, mediafiles, mediafileBlocks, silentMediafile, dislikedMediafiles, rotatedMediafiles, oneToOneSeparate, crossfadeEnabled, lastRotations, logger, tracing) {
        if (crossfadeEnabled === void 0) { crossfadeEnabled = true; }
        this.bannedPerformers = Array(BANNED_PERFORMERS_QUEUE_LENGTH).fill("");
        this.generationMediafileResult = [];
        this.mediafiles = (0, filterMediafiles_1.filterMediafiles)(mediafiles, dislikedMediafiles);
        this.mediafileBlocks = mediafileBlocks;
        var lastRotation = lastRotations[lastRotations.length - 1];
        var lastTime = (0, moment_timezone_1.default)(lastRotation === null || lastRotation === void 0 ? void 0 : lastRotation.playtime);
        this.patternService = new PatternService_1.PatternService({
            streamBlockPattern: blockPattern,
            allBlocks: allBlocks,
            blocksPattern: lastRotation === null || lastRotation === void 0 ? void 0 : lastRotation.blocksPattern,
            blockIndex: lastRotation === null || lastRotation === void 0 ? void 0 : lastRotation.blockIndex,
            lastTime: lastTime,
        });
        this.generationRulesService = new GenerationRulesService_1.GenerationRulesService(mediafileBlocks);
        this.silentMediafile = silentMediafile;
        this.rotatedMediafiles = rotatedMediafiles;
        this.oneToOneSeparate = oneToOneSeparate;
        this.crossfadeEnabled = crossfadeEnabled;
        this.logger = logger;
        this.tracing = tracing;
    }
    MediafileGenerator.prototype.getMediafile = function (context) {
        var e_1, _a;
        var _b = this.patternService.getPatterns(), blocksPattern = _b.blocksPattern, blockIds = _b.blockIds, tagPatterns = _b.tagPatterns;
        if (!blocksPattern.length) {
            return {
                mediafile: this.silentMediafile,
            };
        }
        var filteredMediafiles = (0, utils_1.getFilteredMediafiles)({
            mediafiles: this.mediafiles,
            mediafileBlocks: this.mediafileBlocks,
            availableBlockIds: blockIds,
            oneToOneSeparate: this.oneToOneSeparate,
            rotatedMediafiles: this.rotatedMediafiles,
            lastRotations: context.lastRotations,
            currentPlaylist: this.generationMediafileResult,
        });
        if (!filteredMediafiles.length) {
            return {
                mediafile: this.mediafiles[0],
            };
        }
        var mediafilePassedRulesMap = [];
        try {
            for (var filteredMediafiles_1 = __values(filteredMediafiles), filteredMediafiles_1_1 = filteredMediafiles_1.next(); !filteredMediafiles_1_1.done; filteredMediafiles_1_1 = filteredMediafiles_1.next()) {
                var mediafile = filteredMediafiles_1_1.value;
                var _c = this.generationRulesService.checkRules({
                    mediafile: mediafile,
                    blockIds: blockIds,
                    tagPatterns: tagPatterns,
                    bannedPerformers: this.bannedPerformers,
                }), check = _c.check, performer = _c.performer, blockId = _c.blockId, tagId = _c.tagId;
                if (performer) {
                    mediafilePassedRulesMap.push({
                        mediafile: mediafile,
                        blockId: blockId,
                    });
                }
                if (check) {
                    this.patternService.incrementTagIndex(blockId);
                    return {
                        mediafile: mediafile,
                        blockId: blockId,
                        tagId: tagId,
                    };
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (filteredMediafiles_1_1 && !filteredMediafiles_1_1.done && (_a = filteredMediafiles_1.return)) _a.call(filteredMediafiles_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (!mediafilePassedRulesMap.length) {
            return {
                mediafile: filteredMediafiles[0],
            };
        }
        var mediafileTwoRulesPassed = mediafilePassedRulesMap.find(function (passedRuleMap) { return passedRuleMap.blockId; });
        if (mediafileTwoRulesPassed) {
            return {
                mediafile: mediafileTwoRulesPassed.mediafile,
                blockId: mediafileTwoRulesPassed.blockId,
            };
        }
        return {
            mediafile: mediafilePassedRulesMap[0].mediafile,
        };
    };
    MediafileGenerator.prototype.convertMediafileToRotation = function (mediafile, nextTime, additionalData) {
        var _a = this.patternService.getPatterns(), blocksPattern = _a.blocksPattern, blockIndex = _a.blockIndex;
        var rotation = {
            mediafile: mediafile,
            mediafileId: mediafile.id,
            mediafileType: mediafile.type,
            playtime: nextTime,
            blocksPattern: blocksPattern,
            blockIndex: blockIndex,
            tagId: additionalData === null || additionalData === void 0 ? void 0 : additionalData.tagId,
            blockId: additionalData === null || additionalData === void 0 ? void 0 : additionalData.blockId,
            endTime: nextTime.clone().add(mediafile.duration, "milliseconds"),
        };
        var advancedNextTime = nextTime
            .clone()
            .add(this.crossfadeEnabled ? mediafile.crossfadeDuration : mediafile.duration, "milliseconds");
        return new types_1.GetRotationResult(advancedNextTime, rotation);
    };
    MediafileGenerator.prototype.generate = function (context) {
        var nextTime = context.getNextTime();
        this.patternService.calculateNextPatterns(nextTime);
        var _a = this.getMediafile(context), mediafile = _a.mediafile, blockId = _a.blockId, tagId = _a.tagId;
        this.generationMediafileResult.push(mediafile);
        if (mediafile === null || mediafile === void 0 ? void 0 : mediafile.performerTitle) {
            this.bannedPerformers.pop();
            this.bannedPerformers.unshift(mediafile.performerTitle);
        }
        var result = this.convertMediafileToRotation(mediafile, nextTime, {
            blockId: blockId,
            tagId: tagId,
        });
        context.addRotation(result.rotation, result.nextTime);
    };
    return MediafileGenerator;
}());
exports.MediafileGenerator = MediafileGenerator;
//# sourceMappingURL=index.js.map